import { withTheme, withStyles } from 'material-ui';
import React, { Component } from 'react';
import ResourceIndexGrid from './components/ResourceIndexGrid';
import AppBarSpacing from './utils/AppBarSpacing';

class Resources extends Component {
  render() {
    return (
      <ResourceIndexGrid resources={this.props.resources} indexed={this.props.featured} gridContainerProps={{className: this.props.classes["margin-app_bar_spacing-1"]}}/>
    );
  }
}

export default withTheme()(withStyles(AppBarSpacing)(Resources));


// WEBPACK FOOTER //
// ./src/Resources.js